export enum PortfolioDetailViewSortOptionsEnum {
  AlphabeticalAZ = 'alphabeticalAZ',
  AlphabeticalZA = 'alphabeticalZA',
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt',
}

export const PORTFOLIO_VIEW_SORT_VALUES: Record<
  PortfolioDetailViewSortOptionsEnum,
  { fieldName: string; sortOrder: 1 | -1 }
> = {
  [PortfolioDetailViewSortOptionsEnum.UpdatedAt]: {
    fieldName: 'property.updatedAt',
    sortOrder: -1,
  },
  [PortfolioDetailViewSortOptionsEnum.CreatedAt]: {
    fieldName: 'property.createdAt',
    sortOrder: -1,
  },
  [PortfolioDetailViewSortOptionsEnum.AlphabeticalAZ]: {
    fieldName: 'property.name',
    sortOrder: 1,
  },
  [PortfolioDetailViewSortOptionsEnum.AlphabeticalZA]: {
    fieldName: 'property.name',
    sortOrder: -1,
  },
};
